import React from 'react';
import { Global } from '@emotion/react';
import * as ThemeUI from 'theme-ui';
import { foundations, variants } from '@clariness/base';

const theme = { ...foundations, ...variants } as ThemeUI.Theme;

export const ThemeProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => (
  <ThemeUI.ThemeProvider theme={theme}>
    {/* Theme UI sets border-box on every element. Clarikit's radio centers
        its dot with content-box math, so border-box fills the ring solid. */}
    <Global
      styles={{
        '.Clarikit-RadioButton__Radio': {
          boxSizing: 'content-box',
        },
      }}
    />
    {children}
  </ThemeUI.ThemeProvider>
);
